import { Loader } from "lucide-react";

/**
 * Skeleton component displays a loading indicator with a spinner and message
 * while content is being fetched. Used to show loading state during data retrieval.
 * 
 * @component
 * @returns {JSX.Element} A loading skeleton with spinner and "Just a moment... fetching response" message
 * 
 * @example
 * ```tsx
 * {isLoading ? <Skeleton /> : <Content />}
 * ```
 */
export function Skeleton() {
  return (
    <>
      <div className="m-auto md:max-w-2xl lg:max-w-2xl lg:px-0 lg:max-w-[56rem]">
        <div
          className="
          flex 
          text-primary-500 text-sm
        "
        >
          <Loader className="mr-2 animate-spin" />

          <span>
            Just a moment... fetching response
          </span>
        </div>
      </div>
    </>
  );
}
